module.exports = __webpack_public_path__ + "img/republic-of-the-congo.643dd9c2.svg";